module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    Download Excel file of all emails\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f67cb9ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/reports/Emails.vue
// module id = 586
// module chunks = 0